import gql from 'graphql-tag';
import { List } from 'immutable';

import GraphQLClient, { GraphQLOperationFailed } from '../../adapter/GraphQLClient';
import YahooAdAccount from '../../entity/YahooAdAccount';
import YahooUploadedCreative from '../../entity/YahooUploadedCreative';

export const handleYahooAdError = (err: GraphQLOperationFailed) => {
  switch (err.type) {
    case 'create_token-invalid_params':
      throw new CreateTokenInvalidParamsError();
    case 'create_token-get_access_token_failed':
      throw new CreateTokenGetAccessTokenFailedError();
    case 'create_token-get_amazon_user_info_failed':
      throw new CreateTokenGetAmazonUserInfoFailedError();
    case 'create_token-register_data_failed':
      throw new CreateTokenRegisterDataFailedError();
    case 'linked_list-invalid_params':
      throw new LinkedListInvalidParamsError();
    case 'linkable_list-invalid_params':
      throw new LinkableListInvalidParamsError();
    case 'linkable_list-create_yahoo_client_failed':
      throw new LinkableListCreateYahooClientFailedError();
    case 'linkable_list-list_accounts_failed':
      throw new LinkableListListAccountsFailedError();
    case 'uploaded_creatives-invalid_params':
      throw new UploadedCreativesInvalidParamsError();
    case 'upload_creative-invalid_params':
      throw new UploadCreativeInvalidParamsError();
    case 'upload_creative-token_not_found':
      throw new UploadCreativeTokenNotFoundError();
    case 'upload_creative-create_yahoo_client_failed':
      throw new UploadCreativeCreateYahooClientFailedError();
    case 'upload_creative-create_tmp_file_failed':
      throw new UploadCreativeCreateTmpFileFailedError();
    case 'upload_creative-downloading_creative_failed':
      throw new UploadCreativeDownloadingCreativeFailedError();
    case 'upload_creative-copy_download_creative_failed':
      throw new UploadCreativeCopyDownloadCreativeFailedError();
    case 'upload_creative-register_data_failed':
      throw new UploadCreativeRegisterDataFailedError();
    case 'upload_creative-uploading_failed':
      throw new UploadCreativeUploadingFailedError();
    case 'link_accounts-invalid_params':
      throw new LinkAccountsInvalidParamsError();
    case 'link_accounts-duplicate':
      throw new LinkAccountsDuplicateError();
    case 'link_accounts-register_token_adaccount_failed':
      throw new LinkAccountsRegisterTokenAdaccountFailedError();
    case 'link_accounts-token_not_found':
      throw new LinkAccountsTokenNotFoundError();
    case 'link_accounts-create_yahoo_client_failed':
      throw new LinkAccountsCreateYahooClientFailedError();
    case 'link_accounts-get_account_api_failed':
      throw new LinkAccountsGetAccountApiFailedError();
    case 'link_accounts-register_adaccount_failed':
      throw new LinkAccountsRegisterAdaccountFailedError();
    case 'unlink_accounts-invalid_params':
      throw new UnlinkAccountsInvalidParamsError();
    case 'unlink_accounts-adaccount_not_found':
      throw new UnlinkAccountsAdaccountNotFoundError();
    case 'unlink_accounts-delete_adaccount_failed':
      throw new UnlinkAccountsDeleteAdaccountFailedError();
    case 'upload_creative-validation_error_duplicate':
      throw new UploadCreativeValidationErrorDuplicate();
    case 'upload_creative-validation_error_over_limit':
      throw new UploadCreativeValidationErrorOverLimit();
    case 'upload_creative-validation_error_invalid_aspect_ratio_of_video':
      throw new UploadCreativeValidationErrorInvalidAspectRatioOfVideo();
    case 'upload_creative-validation_error_over_limit_of_file_size':
      throw new UploadCreativeValidationErrorOverLimitOfFileSize();
    case 'upload_creative-validation_error_too_long_video_play_time':
      throw new UploadCreativeValidationErrorTooLongVideoPlayTime();
    case 'upload_creative-validation_error_too_short_video_play_time':
      throw new UploadCreativeValidationErrorTooShortVideoPlayTime();
    case 'upload_creative-validation_error_invalid_video_codec':
      throw new UploadCreativeValidationErrorInvalidVideoCodec();
    case 'upload_creative-validation_error_invalid_audio_codec':
      throw new UploadCreativeValidationErrorInvalidAudioCodec();
    case 'upload_creative-validation_error_invalid_major_brand':
      throw new UploadCreativeValidationErrorInvalidMajorBrand();
    case 'upload_creative-validation_error_invalid_video_index':
      throw new UploadCreativeValidationErrorInvalidVideoIndex();
    case 'upload_creative-validation_error_over_the_frame_rate_limit':
      throw new UploadCreativeValidationErrorOverTheFrameRateLimit();
    case 'upload_creative-validation_error_over_the_audio_volume_limit':
      throw new UploadCreativeValidationErrorOverTheAudioVolumeLimit();
    case 'upload_creative-cannot_fetch_token':
      throw new UploadCreativeCannotFetchToken();
    default:
      throw err;
  }
};
export class CreateTokenInvalidParamsError extends Error {
  public readonly name = 'CreateTokenInvalidParamsError';
  public readonly message = 'message.yahoo_create_token-invalid_params';
  constructor() {
    super();
  }
}

export class CreateTokenGetAccessTokenFailedError extends Error {
  public readonly name = 'CreateTokenGetAccessTokenFailedError';
  public readonly message = 'message.yahoo_create_token-get_access_token_failed';
  constructor() {
    super();
  }
}
export class CreateTokenGetAmazonUserInfoFailedError extends Error {
  public readonly name = 'CreateTokenGetAmazonUserInfoFailedError';
  public readonly message = 'message.yahoo_create_token-get_amazon_user_info_failed';
  constructor() {
    super();
  }
}
export class CreateTokenRegisterDataFailedError extends Error {
  public readonly name = 'CreateTokenRegisterDataFailedError';
  public readonly message = 'message.yahoo_create_token-register_data_failed';
  constructor() {
    super();
  }
}
export class LinkedListInvalidParamsError extends Error {
  public readonly name = 'LinkedListInvalidParamsError';
  public readonly message = 'message.yahoo_linked_list-invalid_params';
  constructor() {
    super();
  }
}
export class LinkableListInvalidParamsError extends Error {
  public readonly name = 'LinkableListInvalidParamsError';
  public readonly message = 'message.yahoo_linkable_list-invalid_params';
  constructor() {
    super();
  }
}
export class LinkableListCreateYahooClientFailedError extends Error {
  public readonly name = 'LinkableListCreateYahooClientFailedError';
  public readonly message = 'message.yahoo_linkable_list-create_yahoo_client_failed';
  constructor() {
    super();
  }
}
export class LinkableListListAccountsFailedError extends Error {
  public readonly name = 'LinkableListListAccountsFailedError';
  public readonly message = 'message.yahoo_linkable_list-list_accounts_failed';
  constructor() {
    super();
  }
}
export class UploadedCreativesInvalidParamsError extends Error {
  public readonly name = 'UploadedCreativesInvalidParamsError';
  public readonly message = 'message.yahoo_uploaded_creatives-invalid_params';
  constructor() {
    super();
  }
}
export class UploadCreativeInvalidParamsError extends Error {
  public readonly name = 'UploadCreativeInvalidParamsError';
  public readonly message = 'message.yahoo_upload_creative-invalid_params';
  constructor() {
    super();
  }
}
export class UploadCreativeTokenNotFoundError extends Error {
  public readonly name = 'UploadCreativeTokenNotFoundError';
  public readonly message = 'message.yahoo_upload_creative-token_not_found';
  constructor() {
    super();
  }
}
export class UploadCreativeCreateYahooClientFailedError extends Error {
  public readonly name = 'UploadCreativeCreateYahooClientFailedError';
  public readonly message = 'message.yahoo_upload_creative-create_yahoo_client_failed';
  constructor() {
    super();
  }
}
export class UploadCreativeCreateTmpFileFailedError extends Error {
  public readonly name = 'UploadCreativeCreateTmpFileFailedError';
  public readonly message = 'message.yahoo_upload_creative-create_tmp_file_failed';
  constructor() {
    super();
  }
}
export class UploadCreativeDownloadingCreativeFailedError extends Error {
  public readonly name = 'UploadCreativeDownloadingCreativeFailedError';
  public readonly message = 'message.yahoo_upload_creative-downloading_creative_failed';
  constructor() {
    super();
  }
}
export class UploadCreativeCopyDownloadCreativeFailedError extends Error {
  public readonly name = 'UploadCreativeCopyDownloadCreativeFailedError';
  public readonly message = 'message.yahoo_upload_creative-copy_download_creative_failed';
  constructor() {
    super();
  }
}
export class UploadCreativeRegisterDataFailedError extends Error {
  public readonly name = 'UploadCreativeRegisterDataFailedError';
  public readonly message = 'message.yahoo_upload_creative-register_data_failed';
  constructor() {
    super();
  }
}
export class UploadCreativeUploadingFailedError extends Error {
  public readonly name = 'UploadCreativeUploadingFailedError';
  public readonly message = 'message.yahoo_upload_creative-uploading_failed';
  constructor() {
    super();
  }
}
export class LinkAccountsInvalidParamsError extends Error {
  public readonly name = 'LinkAccountsInvalidParamsError';
  public readonly message = 'message.yahoo_link_accounts-invalid_params';
  constructor() {
    super();
  }
}
export class LinkAccountsDuplicateError extends Error {
  public readonly name = 'LinkAccountsDuplicateError';
  public readonly message = 'message.yahoo_link_accounts-duplicate';
  constructor() {
    super();
  }
}
export class LinkAccountsRegisterTokenAdaccountFailedError extends Error {
  public readonly name = 'LinkAccountsRegisterTokenAdaccountFailedError';
  public readonly message = 'message.yahoo_link_accounts-register_token_adaccount_failed';
  constructor() {
    super();
  }
}
export class LinkAccountsTokenNotFoundError extends Error {
  public readonly name = 'LinkAccountsTokenNotFoundError';
  public readonly message = 'message.yahoo_link_accounts-token_not_found';
  constructor() {
    super();
  }
}
export class LinkAccountsCreateYahooClientFailedError extends Error {
  public readonly name = 'LinkAccountsCreateYahooClientFailedError';
  public readonly message = 'message.yahoo_link_accounts-create_yahoo_client_failed';
  constructor() {
    super();
  }
}
export class LinkAccountsGetAccountApiFailedError extends Error {
  public readonly name = 'LinkAccountsGetAccountApiFailedError';
  public readonly message = 'message.yahoo_link_accounts-get_account_api_failed';
  constructor() {
    super();
  }
}
export class LinkAccountsRegisterAdaccountFailedError extends Error {
  public readonly name = 'LinkAccountsRegisterAdaccountFailedError';
  public readonly message = 'message.yahoo_link_accounts-register_adaccount_failed';
  constructor() {
    super();
  }
}
export class UnlinkAccountsInvalidParamsError extends Error {
  public readonly name = 'UnlinkAccountsInvalidParamsError';
  public readonly message = 'message.yahoo_unlink_accounts-invalid_params';
  constructor() {
    super();
  }
}
export class UnlinkAccountsAdaccountNotFoundError extends Error {
  public readonly name = 'UnlinkAccountsAdaccountNotFoundError';
  public readonly message = 'message.yahoo_unlink_accounts-adaccount_not_found';
  constructor() {
    super();
  }
}
export class UnlinkAccountsDeleteAdaccountFailedError extends Error {
  public readonly name = 'UnlinkAccountsDeleteAdaccountFailedError';
  public readonly message = 'message.yahoo_unlink_accounts-delete_adaccount_failed';
  constructor() {
    super();
  }
}

export class UploadCreativeValidationErrorDuplicate extends Error {
  public readonly name = 'UploadCreativeValidationErrorDuplicate';
  public readonly message = 'message.yahoo_upload_creative-validation_error_duplicate';
  constructor() {
    super();
  }
}

export class UploadCreativeValidationErrorOverLimit extends Error {
  public readonly name = 'UploadCreativeValidationErrorOverLimit';
  public readonly message = 'message.yahoo_upload_creative-validation_error_over_limit';
  constructor() {
    super();
  }
}

export class UploadCreativeValidationErrorInvalidAspectRatioOfVideo extends Error {
  public readonly name = 'UploadCreativeValidationErrorInvalidAspectRatioOfVideo';
  public readonly message = 'message.yahoo_upload_creative-validation_error_invalid_aspect_ratio_of_video';
  constructor() {
    super();
  }
}

export class UploadCreativeValidationErrorOverLimitOfFileSize extends Error {
  public readonly name = 'UploadCreativeValidationErrorOverLimitOfFileSize';
  public readonly message = 'message.yahoo_upload_creative-validation_error_over_limit_of_file_size';
  constructor() {
    super();
  }
}

export class UploadCreativeValidationErrorTooLongVideoPlayTime extends Error {
  public readonly name = 'UploadCreativeValidationErrorTooLongVideoPlayTime';
  public readonly message = 'message.yahoo_upload_creative-validation_error_too_long_video_play_time';
  constructor() {
    super();
  }
}

export class UploadCreativeValidationErrorTooShortVideoPlayTime extends Error {
  public readonly name = 'UploadCreativeValidationErrorTooShortVideoPlayTime';
  public readonly message = 'message.yahoo_upload_creative-validation_error_too_short_video_play_time';
  constructor() {
    super();
  }
}

export class UploadCreativeValidationErrorInvalidVideoCodec extends Error {
  public readonly name = 'UploadCreativeValidationErrorInvalidVideoCodec';
  public readonly message = 'message.yahoo_upload_creative-validation_error_invalid_video_codec';
  constructor() {
    super();
  }
}

export class UploadCreativeValidationErrorInvalidAudioCodec extends Error {
  public readonly name = 'UploadCreativeValidationErrorInvalidAudioCodec';
  public readonly message = 'message.yahoo_upload_creative-validation_error_invalid_audio_codec';
  constructor() {
    super();
  }
}

export class UploadCreativeValidationErrorInvalidMajorBrand extends Error {
  public readonly name = 'UploadCreativeValidationErrorInvalidMajorBrand';
  public readonly message = 'message.yahoo_upload_creative-validation_error_invalid_major_brand';
  constructor() {
    super();
  }
}

export class UploadCreativeValidationErrorInvalidVideoIndex extends Error {
  public readonly name = 'UploadCreativeValidationErrorInvalidVideoIndex';
  public readonly message = 'message.yahoo_upload_creative-validation_error_invalid_video_index';
  constructor() {
    super();
  }
}

export class UploadCreativeValidationErrorOverTheFrameRateLimit extends Error {
  public readonly name = 'UploadCreativeValidationErrorOverTheFrameRateLimit';
  public readonly message = 'message.yahoo_upload_creative-validation_error_over_the_frame_rate_limit';
  constructor() {
    super();
  }
}

export class UploadCreativeValidationErrorOverTheAudioVolumeLimit extends Error {
  public readonly name = 'UploadCreativeValidationErrorOverTheAudioVolumeLimit';
  public readonly message = 'message.yahoo_upload_creative-validation_error_over_the_audio_volume_limit';
  constructor() {
    super();
  }
}

export class UploadCreativeCannotFetchToken extends Error {
  public readonly name = 'UploadCreativeCannotFetchToken';
  public readonly message = 'message.yahoo_upload_creative-cannot_fetch_token';
  constructor() {
    super();
  }
}

class YahooAdWebApi {
  private readonly graphqlClient: GraphQLClient;

  constructor({ graphqlClient }: { graphqlClient: GraphQLClient }) {
    this.graphqlClient = graphqlClient;
  }

  /**
   * @param organizationId
   * 連携済みYahooAdAccountの配列が返却されます
   */

  public getAllIntegratedAdAccounts = async (organizationId: string): Promise<List<YahooAdAccount>> => {
    try {
      const result = await this.graphqlClient.query(
        gql`
          query integratedYahooAdAccounts($organizationId: ID!) {
            integratedYahooAdAccounts(organizationId: $organizationId) {
              id
              adAccountId
              name
            }
          }
        `,
        { organizationId },
      );
      const items = result.integratedYahooAdAccounts as YahooAdAccount[];
      return List(items);
    } catch (err) {
      handleYahooAdError(err);
      throw err;
    }
  };

  /**
   * @param organizationId
   * @param tokenId
   * YahooAdAccountのtokenIdを渡し、連携可能なアカウント一覧を返します
   */
  public getAllAccessibleYahooAdAccounts = async (
    organizationId: string,
    tokenId: string,
  ): Promise<List<YahooAdAccount>> => {
    try {
      const result = await this.graphqlClient.query(
        gql`
          query accessibleYahooAdAccounts($organizationId: ID!, $tokenId: ID!) {
            accessibleYahooAdAccounts(organizationId: $organizationId, tokenId: $tokenId) {
              id
              adAccountId
              name
            }
          }
        `,
        { organizationId, tokenId },
      );
      const items = result.accessibleYahooAdAccounts as YahooAdAccount[];
      return List(items);
    } catch (err) {
      handleYahooAdError(err);
      throw err;
    }
  };

  /**
   * @param authCode
   * 連携するyahooAdAccountのauthCodeを渡し、tokenIdを受け取ります
   */
  public registerYahooAccount = async (authCode: string, organizationId: string): Promise<string> => {
    try {
      const result = await this.graphqlClient.query(
        gql`
          mutation registerYahooToken($authCode: String!, $organizationId: ID!) {
            registerYahooToken(authCode: $authCode, organizationId: $organizationId)
          }
        `,
        { authCode, organizationId },
      );
      const item = result.registerYahooToken as string;
      return item;
    } catch (err) {
      handleYahooAdError(err);
      throw err;
    }
  };

  /**
   * @param yahooAdAccountId
   * @param tokenId
   * @param organizationId
   * YahooAdAccount連携に必要なパラメータを渡し、連携を行います
   * 連携成功の場合true, 失敗の場合false
   */
  public integrateAdAccount = async (
    yahooAdAccountId: string,
    tokenId: string,
    organizationId: string,
  ): Promise<boolean> => {
    try {
      const result = await this.graphqlClient.query(
        gql`
          mutation integrateYahooAdAccount($organizationId: ID!, $yahooAdAccountId: ID!, $tokenId: ID!) {
            integrateYahooAdAccount(
              organizationId: $organizationId
              yahooAdAccountId: $yahooAdAccountId
              tokenId: $tokenId
            )
          }
        `,
        { yahooAdAccountId, organizationId, tokenId },
      );
      return result.integrateYahooAdAccount as boolean;
    } catch (err) {
      handleYahooAdError(err);
      throw err;
    }
  };

  /**
   * @param organizationId
   * @param yahooAdAccountId
   * yahooAdAccountの連携を解除します
   */
  public unlinkYahooAdAccount = async (organizationId: string, yahooAdAccountId: string): Promise<boolean> => {
    try {
      const result = await this.graphqlClient.query(
        gql`
          mutation unlinkYahooAdAccount($organizationId: ID!, $yahooAdAccountId: ID!) {
            unlinkYahooAdAccount(organizationId: $organizationId, yahooAdAccountId: $yahooAdAccountId)
          }
        `,
        { organizationId, yahooAdAccountId },
      );
      return result.unlinkYahooAdAccount;
    } catch (err) {
      handleYahooAdError(err);
      throw err;
    }
  };

  /**
   * @param creativeId
   * @param organizationId
   * @param projectId
   * YahooAdAccountに対して、クリエイティブ連携を行います
   */
  public sendCreativeToYahoo = async (
    creativeId: string,
    organizationId: string,
    projectId: string,
    yahooAdAccountId: string,
  ): Promise<boolean> => {
    try {
      const result = await this.graphqlClient.query(
        gql`
          mutation sendCreativeToYahoo(
            $projectId: ID!
            $yahooAdAccountId: ID!
            $creativeId: ID!
            $organizationId: ID!
          ) {
            sendCreativeToYahoo(
              projectId: $projectId
              yahooAdAccountId: $yahooAdAccountId
              organizationId: $organizationId
              creativeId: $creativeId
            ) {
              id
            }
          }
        `,
        { projectId, yahooAdAccountId, creativeId, organizationId },
      );
      return result.sendCreativeToYahoo;
    } catch (err) {
      handleYahooAdError(err);
      throw err;
    }
  };

  /**
   * @param organizationId
   * @param creativeIds
   * YahooAdAccountに紐づいているクリエイティブを返します
   */
  public getUploadedYahooCreatives = async (
    organizationId: string,
    creativeIds: string[],
  ): Promise<YahooUploadedCreative[]> => {
    try {
      const result = await this.graphqlClient.query(
        gql`
          query uploadedYahooCreatives($organizationId: ID!, $creativeIds: [ID!]!) {
            uploadedYahooCreatives(organizationId: $organizationId, creativeIds: $creativeIds) {
              creativeId
              mediaId
              uploadedAt
            }
          }
        `,
        { creativeIds, organizationId },
      );
      return result.uploadedYahooCreatives;
    } catch (err) {
      handleYahooAdError(err);
      throw err;
    }
  };
}

export default YahooAdWebApi;
